import styled, { FlattenSimpleInterpolation } from "styled-components/macro";
import { Z_INDEX } from "constants/constants";
import {
  darkBlue,
  darkModeCardBackgroundColor,
  medBlue,
} from "constants/colors";

export const CollapsibleConfigStyles = styled.div<{
  $isDarkMode: boolean;
  $isSettingsPage?: boolean;
  $customCss?: string | FlattenSimpleInterpolation;
}>`
  position: relative;
  z-index: ${Z_INDEX.L10};
  background: ${({ $isDarkMode }) =>
    $isDarkMode ? darkModeCardBackgroundColor : "white"};
  width: ${props => (props.$isSettingsPage ? "100%" : "300px")};
  .switchWrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .name {
      flex-grow: 1;
    }
  }
  .Mui-checked {
    .MuiSwitch-thumb {
      color: ${darkBlue};
    }
  }
  .checked .MuiSwitch-track {
    background-color: ${medBlue} !important;
  }
  .label {
    line-height: 24px;
  }
  .subtitle {
    line-height: 18px;
  }
  .dayStart {
    align-self: center;
  }
  ${({ $customCss }) => $customCss || ``}
`;
